import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {PropProvider} from './context';
import {FormspreeProvider} from "@formspree/react";

ReactDOM.render(
  <PropProvider>
    <FormspreeProvider project="1679758056419753277">
    <BrowserRouter>
      <App />
    </BrowserRouter>
    </FormspreeProvider>
  </PropProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
